export default __webpack_public_path__ + "static/media/arrowdoodle.66f91c2d.png";